import { useParams, useSearchParams } from "react-router-dom";

import { useOffers } from "./hooks/useOffers";

import Alerts from "@/components/Alerts";
import OfferCard from "./components/OfferCard";
import Pagination from "@/components/Pagination";
import PageSkeleton from "./components/PageSkeleton";

function Offers() {
    const { grade } = useParams();
    const [searchParams] = useSearchParams();

    const filter = { field: "grade", value: grade };

    const include = [
        { field: "VideosDuration", value: "true" },
        { field: "VideosCount", value: "true" },
        { field: "QuizzesCount", value: "true" },
        { field: "StudentsCount", value: "true" },
        { field: "Discount", value: "true" },
    ];

    const includeFields = ["lectures", "lecturesCount", "lecturesExists"];

    const perPage = 5;

    const page = searchParams.get("page")
        ? parseInt(searchParams.get("page"), 10) < 1
            ? 1
            : parseInt(searchParams.get("page"), 10)
        : 1;

    const { isPending, offers } = useOffers({
        filter,
        include,
        includeFields,
        page,
        perPage,
    });

    const totalPages = Math.ceil(offers?.meta.total / offers?.meta.per_page);

    return (
        <section className="container flex flex-col items-center justify-center px-4 pb-4 mx-auto text-sm md:text-lg">
            <h2 className="self-start text-2xl md:text-4xl pt-14 text-secondary-color">
                احدث <span className="text-secondary-color">العروض </span>
            </h2>
            <div className="w-full">
                {isPending && <PageSkeleton />}

                {!offers?.data?.length && !isPending ? (
                    <Alerts
                        variant={"filled"}
                        severity={"error"}
                        message={"لا يوجد عروض"}
                    />
                ) : (
                    offers?.data.map((offer) => {
                        return <OfferCard offer={offer} key={offer?.id} />;
                    })
                )}
            </div>
            {offers?.data?.length && !offers?.meta.total < perPage ? (
                <Pagination total={totalPages} className="mt-5" />
            ) : (
                ""
            )}
        </section>
    );
}

export default Offers;
